<template>
    <ul class="list-none space-y-3">
        <li
            v-for="(message, index) in messages"
            :id="'message-' + message.id"
            :key="message.id ? 'message-' + message.id : 'message-index-' + index"
            class="mb-3"
        >
            <!-- Received Message -->
            <div
                v-if="!isOwnMessage(message)"
                class="flex space-x-3"
            >
                <img
                    class="object-cover w-8 h-8 mx-1 rounded-full"
                    :src="message.sender.profile_photo_url"
                    :alt="message.sender.name"
                />
                <div>
                    <p class="px-3 py-1 bg-gray-200 rounded-2xl">
                        {{ message.message }}
                    </p>
                    <p class="ml-2 text-xs text-gray-400">
                        {{ message.created_at | fromNow }}
                    </p>
                </div>
            </div>

            <div
                v-else
                class="flex justify-end"
            >
                <div class="text-right">
                    <p class="inline-block px-3 py-1 text-white bg-blue-500 rounded-2xl">
                        {{ message.message }}
                    </p>
                    <p class="mr-2 text-xs text-gray-400">
                        {{ message.created_at | fromNow }}
                    </p>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            messages: {
                type: Array,
                required: true,
            },

            // only used when admin is browsing the messages and not user
            wholesaler: {
                type: Object,
                required: false,
                default: null,
            },
        },

        methods: {
            isOwnMessage(message) {
                if (!this.isAdmin && message.sender.id === this.$page.props.user.id) {
                    return true;
                }
                // if admin is browsing the messages and not user, treat wholesaler as user
                if (this.isAdmin && message.sender.id === this.wholesaler.id) {
                    return true;
                }
                return false;
            },
        },
    };
</script>
